import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import '../css/Project_overview.css';
import 'animate.css';

const ProjectOverview = () => {
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div>
      <div className={`project-overview-navbar animate__animated animate__headShake ${isSticky ? 'project-overview-sticky' : ''}`}>
        {/* Use NavLink for navigation links */}
        <NavLink to="/block_diagram" exact activeClassName="active">Block Diagram</NavLink>
        <NavLink to="/system_architecture" activeClassName="active">System Architecture</NavLink>
        <NavLink to="/gantt_chart" activeClassName="active">Gantt Chart</NavLink>
        <NavLink to="/week" activeClassName="active">Weekly Update</NavLink>
        <NavLink to="/sketch" activeClassName="active">Sketch Diagram</NavLink>
      </div>

      <div className="project-overview-content">
        {/* Your page content goes here */}
      </div>
    </div>
  );
};

export default ProjectOverview;
